import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class RecordGuard  {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const params = route.paramMap.get('slug');

    const paramsArray = params.split('-');
    const id = paramsArray[paramsArray.length - 1];

    if (Number(id)) {
      return true;
    } else {
      this.router.navigate(['/']);
    }
    return false;
  }
}
